__turbopack_context__.v({
  "content": "select-module__Vu0smW__content",
  "icon": "select-module__Vu0smW__icon",
  "item": "select-module__Vu0smW__item",
  "label": "select-module__Vu0smW__label",
  "separator": "select-module__Vu0smW__separator",
  "slideDown": "select-module__Vu0smW__slideDown",
  "trigger": "select-module__Vu0smW__trigger",
  "viewport": "select-module__Vu0smW__viewport",
});
